import { useEffect, useState } from 'react';
import { getLocalidades } from '../utils/inmuebles.service';

export function useLocalidades() {
  const [localidades, setLocalidades] = useState<Record<number, string>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getLocalidades();
        setLocalidades(res);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { localidades, loading, error };
}